import { EventSchedule, Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateEventSchedules = generateAPI<
  {
    body: {
      eventSchedules: EventSchedule[];
    };
  },
  Wedding
>("put", "wedding/event-schedules", "wedding/");
